import { useExternalScript } from '@whistler-ui/k2/hooks/UseExternalScriptOptions';

import { SETTINGS } from '../../constants';
import useRenderIf from '../../hooks/useRenderIf';

const HubSpotTracingConfig = () => {
  const { isNL } = useRenderIf();

  useExternalScript({
    src: 'https://js.hs-scripts.com/19519497.js',
    id: 'hs-script-loader',
    enabled: SETTINGS.IS_PROD && isNL,
  });

  return null;
};

export default HubSpotTracingConfig;
